export const APP_NAME = 'Faça o seu melhor atendimento.'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
